import { render, staticRenderFns } from "./IncomeAdminComponent.vue?vue&type=template&id=27c528f7&scoped=true"
import script from "./IncomeAdminComponent.vue?vue&type=script&lang=js"
export * from "./IncomeAdminComponent.vue?vue&type=script&lang=js"
import style0 from "./IncomeAdminComponent.vue?vue&type=style&index=0&id=27c528f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c528f7",
  null
  
)

export default component.exports